import clsx from "clsx";
import {
  Children,
  cloneElement,
  isValidElement,
  ReactElement,
  SVGProps,
  SVGAttributes,
  HTMLAttributes,
} from "react";
import { VisuallyHidden } from "../visually-hidden";
import classes from "./icon.module.css";

type IconProps = {
  children: ReactElement<SVGProps<SVGSVGElement>>;
  label?: string;
};

type ClientProps<T> = Pick<IconProps, "label"> & T;

export type IconClientSVGProps = ClientProps<SVGAttributes<SVGSVGElement>>;
export type IconClientSpanProps = ClientProps<HTMLAttributes<HTMLSpanElement>>;

export const Icon = ({ label, children }: IconProps) => {
  const child = Children.only(children);

  if (!child || !isValidElement(child)) {
    return null;
  }

  const enrichedChild = cloneElement(child, {
    className: clsx(classes.root, child.props.className),
    "aria-hidden": "true",
    focusable: "false",
    ...(child.type === "svg" && {
      height: "1em",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      fill: child.props.fill || "none",
    }),
  });

  return (
    <>
      {enrichedChild}
      {label ? <VisuallyHidden>{label}</VisuallyHidden> : null}
    </>
  );
};

Icon.displayName = "Icon";
